import React from 'react';
import { ArrowRight } from 'lucide-react';
import { trackWhatsAppClick } from '../../utils/analytics';

const MESSAGE = 'Olá! Vim pelo site da Coutin Studio e quero um orçamento.';
export const WA_HREF = `https://wa.me/5545988068508?text=${encodeURIComponent(MESSAGE)}`;

export const WhatsIcon = ({ className = 'w-8 h-8' }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12.057 0H12c-6.627 0-12 5.373-12 12 0 2.129.546 4.13 1.506 5.876L.057 24l6.305-1.654C8.075 23.439 10.003 24 12 24h.057c6.627 0 12-5.373 12-12 0-6.627-5.373-12-11.943-12zM12 22.067h-.045c-1.78 0-3.515-.477-5.024-1.379l-.36-.213-3.737.98 1-3.644-.235-.374A9.913 9.913 0 012.067 12C2.067 6.527 6.527 2.067 12 2.067c2.654 0 5.143 1.034 7.022 2.911A9.864 9.864 0 0121.933 12c0 5.473-4.46 9.933-9.933 9.933z" />
  </svg>
);

export const WhatsButton = ({ source, testId, title = 'Solicite seu orçamento' }) => (
  <a
    href={WA_HREF}
    target="_blank"
    rel="noopener noreferrer"
    onClick={() => trackWhatsAppClick(source)}
    data-testid={testId}
    className="group flex items-center gap-4 sm:gap-6 w-full rounded-xl bg-[var(--sh-teal)] text-[#06110F] px-5 sm:px-8 py-4 shadow-[0_18px_50px_-18px_rgba(47,224,197,0.7)] transition-[transform,box-shadow,background-color] duration-300 hover:-translate-y-0.5 hover:bg-[#5BEBD5] active:translate-y-0"
  >
    <WhatsIcon className="w-8 h-8 sm:w-10 sm:h-10 shrink-0" />
    <span className="flex-1 min-w-0 text-left">
      <span className="sh-display block text-3xl sm:text-4xl">{title}</span>
      <span className="block font-semibold text-base sm:text-lg mt-1">(45) 98806-8508</span>
    </span>
    <ArrowRight className="w-7 h-7 shrink-0 transition-transform duration-300 group-hover:translate-x-1.5" />
  </a>
);
